import { render, staticRenderFns } from "./Storyblok.vue?vue&type=template&id=122e023d&"
import script from "./Storyblok.vue?vue&type=script&lang=js&"
export * from "./Storyblok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports